{
  "fixtureId": "523e1018-5643-4af6-883b-864f9ad72e25",
  "matchdayId": "ddbffe11-0aab-4d64-80eb-61ad2fe862c8",
  "status": "WAITING_FOR_POINTS",
  "modifiersFrozenAt": "2026-10-10T21:08:27.484667876Z",
  "ruleSetVersion": 2,
  "attendancePercent": 80.00,
  "home": {
    "clubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
    "staffRatings": {
      "DEFENCE": 1.0,
      "GOALKEEPER": 1.0,
      "MIDFIELD": 1.0,
      "FORWARD": 1.0
    },
    "recentOutcomes": [],
    "players": [
      {
        "playerInstanceId": "06526260-bb0d-4c53-85fd-63f6cbbe2ec2",
        "playerDefinitionId": "47415516-4953-5a6a-8851-dc22e554e150",
        "line": "GOALKEEPER",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Julen Agirrezabala"
      },
      {
        "playerInstanceId": "8ba9e687-82fb-44aa-96e4-62d7f9585219",
        "playerDefinitionId": "e67969e8-992e-5624-8576-11b15435cf3d",
        "line": "DEFENCE",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Dani Vivian"
      },
      {
        "playerInstanceId": "a904ae0a-1040-bdd2-668b-92cf29b1727f",
        "playerDefinitionId": "39077f36-252f-e8e4-184e-878d0b4b7091",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "e2725664-993e-a3bb-220b-a3f7d1a5b3a0",
        "playerDefinitionId": "a7c23424-752b-202a-5011-1b2dd2545879",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "3ab26eed-28c0-41df-9e64-cb11cedaddd8",
        "playerDefinitionId": "15524027-c455-57e6-b90a-0781819e1570",
        "line": "DEFENCE",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Aitor Paredes"
      },
      {
        "playerInstanceId": "263ee12f-3935-4092-bba7-8d7c3600f32c",
        "playerDefinitionId": "b1a14bc4-6411-56c4-b49d-bd448b7a36de",
        "line": "MIDFIELD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Beñat Prados"
      },
      {
        "playerInstanceId": "6774caaf-918c-47ec-9ecb-902434156733",
        "playerDefinitionId": "778c494b-2ec4-5c50-a3bd-ba248524e251",
        "line": "MIDFIELD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Mikel Jauregizar"
      },
      {
        "playerInstanceId": "93c5e7c1-4fd3-4bfe-b924-4f5bf2a232a3",
        "playerDefinitionId": "daae4b97-96e4-5a7d-8397-f10911e8bf2b",
        "line": "FORWARD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Iñaki Williams"
      },
      {
        "playerInstanceId": "feb5c184-9500-4cc8-9663-71bcb30b3314",
        "playerDefinitionId": "16167299-c6af-5999-982c-cd199d840c54",
        "line": "FORWARD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Nico Williams"
      },
      {
        "playerInstanceId": "3c0493bf-c27e-4d4f-982a-8dfd95b24e70",
        "playerDefinitionId": "ec2b5909-e3bb-5e70-a134-fb13104dffd6",
        "line": "FORWARD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Gorka Guruzeta"
      },
      {
        "playerInstanceId": "639f5c8e-c4fb-4052-9731-5d583579edef",
        "playerDefinitionId": "e86eb34b-e58c-502d-a4e2-26701e285152",
        "line": "FORWARD",
        "type": "REAL",
        "status": "PENDING",
        "points": null,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Álex Berenguer"
      }
    ],
    "score": {
      "clubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "attendanceModifierPercent": 3.00,
      "formModifierPercent": 0,
      "goals": 0,
      "optionB": {
        "staffModifierPercents": {
          "DEFENCE": 1.0,
          "GOALKEEPER": 1.0,
          "MIDFIELD": 1.0,
          "FORWARD": 1.0
        },
        "staffAdjustedPower": {
          "attack": 0.2020,
          "midfield": 0.4040,
          "defense": 2.0200
        },
        "offensiveStrength": 0.09982193278098435531152653204126966,
        "afterAttendance": 0.1028165907644138859708723280025077498,
        "goalInput": 0.1028165907644138859708723280025077498
      }
    }
  },
  "away": {
    "clubId": "17583470-dc2a-503e-aead-9b61d5632638",
    "staffRatings": {
      "DEFENCE": 1.0,
      "GOALKEEPER": 1.0,
      "MIDFIELD": 1.0,
      "FORWARD": 1.0
    },
    "recentOutcomes": [],
    "players": [
      {
        "playerInstanceId": "a21ec976-479f-210b-b8f3-bde617403611",
        "playerDefinitionId": "a3d9a694-1960-0416-d3b9-6984b32570c3",
        "line": "GOALKEEPER",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Portero Amateur"
      },
      {
        "playerInstanceId": "8fa52912-080f-be1b-db73-065e34a67046",
        "playerDefinitionId": "d8f20bab-7f3b-9bca-3290-12da4a5aee14",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "9b29ba2c-c0e5-872b-1a66-ad2c41ea8800",
        "playerDefinitionId": "008a100c-f291-3a65-ea5a-6d2bf12dcd32",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "a904ae0a-1040-bdd2-668b-92cf29b1727f",
        "playerDefinitionId": "39077f36-252f-e8e4-184e-878d0b4b7091",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "e2725664-993e-a3bb-220b-a3f7d1a5b3a0",
        "playerDefinitionId": "a7c23424-752b-202a-5011-1b2dd2545879",
        "line": "DEFENCE",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Defensa Amateur"
      },
      {
        "playerInstanceId": "8480aa8d-cc24-6f69-e368-9e24f67d5db2",
        "playerDefinitionId": "fcc34b54-4b45-2856-3cc4-e74a55b9444e",
        "line": "MIDFIELD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Medio Amateur"
      },
      {
        "playerInstanceId": "0302a568-018b-39e7-db58-cdd5509290e9",
        "playerDefinitionId": "dc2691a7-9230-4e99-0eab-699eb596a546",
        "line": "MIDFIELD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Medio Amateur"
      },
      {
        "playerInstanceId": "2c6a8a81-fdaf-763d-12e4-d8d245229b0f",
        "playerDefinitionId": "8dab0723-171f-010c-3d2f-10aeded72748",
        "line": "MIDFIELD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Medio Amateur"
      },
      {
        "playerInstanceId": "5e778a66-9561-0d80-2d90-cf2fedf749f5",
        "playerDefinitionId": "de826903-3c0e-6c7e-cfcf-5fc56d460133",
        "line": "MIDFIELD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Medio Amateur"
      },
      {
        "playerInstanceId": "0c9c9335-17cf-0656-1ebe-925dad27f108",
        "playerDefinitionId": "cf0af798-4492-03e8-b4f6-22b2a18caa24",
        "line": "FORWARD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Delantero Amateur"
      },
      {
        "playerInstanceId": "6b3d8f71-8f73-4dbb-a9fd-437e51b8f09b",
        "playerDefinitionId": "53899e85-78c4-a986-d7dd-ec452c661080",
        "line": "FORWARD",
        "type": "AMATEUR",
        "status": "AVAILABLE",
        "points": 1,
        "performanceId": null,
        "performanceRevision": null,
        "displayName": "Delantero Amateur"
      }
    ],
    "score": {
      "clubId": "17583470-dc2a-503e-aead-9b61d5632638",
      "attendanceModifierPercent": 0,
      "formModifierPercent": 0,
      "goals": 1,
      "optionB": {
        "staffModifierPercents": {
          "DEFENCE": 1.0,
          "GOALKEEPER": 1.0,
          "MIDFIELD": 1.0,
          "FORWARD": 1.0
        },
        "staffAdjustedPower": {
          "attack": 4.0400,
          "midfield": 5.2520,
          "defense": 6.7670
        },
        "offensiveStrength": 3.937247342863952270368776434715527,
        "afterAttendance": 3.937247342863952270368776434715527,
        "goalInput": 3.937247342863952270368776434715527
      }
    }
  },
  "homeGoals": null,
  "awayGoals": null,
  "updatedAt": "2026-10-10T21:08:28.002213446Z"
}
